import { getApi } from 'api';
import { AxiosResponse } from 'axios';
import { ITranslationRow } from 'modules/translations/types';

export const getAllTranslationsRequest = async (): Promise<ITranslationRow[]> => {
  const response: AxiosResponse<ITranslationRow[]> = await getApi().get(`Translations/GetAllTranslations`);
  return response.data;
};

export const addOrUpdateTranslationRequest = async (translation: ITranslationRow): Promise<void> => {
  const response: AxiosResponse<void> = await getApi().post('Translations/AddOrUpdateTranslation', translation);
  return response.data;
};

export const deleteTranslationRequest = async (translationKeyId: number): Promise<void> => {
  const response: AxiosResponse<void> = await getApi().delete(`Translations/DeleteTranslation/${translationKeyId}`);
  return response.data;
};
